import axios from 'axios';
import { apiUrl, authHeader } from '../WeddingDay/runtime';
import { REQUEST_TIMEOUT_MS } from '../constants';

// The booklet hangs off the wedding day brief, so it shares that form's
// deep link and auth. Each app configures both once, through configureWeddingDay.
const url = (bookingId, briefUuid) =>
  apiUrl(`/api/booking/wedding-day/${bookingId}/${briefUuid}/faq/`);

const unwrap = (data) => {
  if (data && data.success === false) {
    const err = new Error(data.message || 'That could not be saved.');
    err.code = data.code;
    throw err;
  }
  return data;
};

// GET wedding-day/<booking_id>/<brief_uuid>/faq/
export const fetchFaq = async ({ bookingId, briefUuid }) => {
  const { data } = await axios.get(url(bookingId, briefUuid), {
    headers: { Authorization: authHeader() },
    timeout: REQUEST_TIMEOUT_MS,
  });
  return unwrap(data);
};

// POST wedding-day/<booking_id>/<brief_uuid>/faq/
// Every topic, ticked or not, every time: a save never half applies, and ops
// sees what was left unticked as well as what was ticked.
export const saveFaq = async ({ bookingId, briefUuid, topics, submit }) => {
  const { data } = await axios.post(
    url(bookingId, briefUuid),
    { topics, submit: submit === true },
    { headers: { Authorization: authHeader() }, timeout: REQUEST_TIMEOUT_MS }
  );
  return unwrap(data);
};
